// HR Dashboard Data
import Img from "../src/assets/Avatar.png";
import assetsImg from "../src/assets/assetsImg.png";
import EngagementImg from "../src/assets/engagement.png";
import smallImage from "../src/assets/engImg.png";
import Debbie from "../src/assets/chat.png";
import HR from "../src/assets/hr.png";
import hrOne from "../src/assets/hrOne.png";
import hrTwo from "../src/assets/chat.png";
import hrThree from "../src/assets/hr3.png";
import hrFour from "../src/assets/hr4.png";
import James from "../src/assets/James.png";
import Gideon from "../src/assets/gideon.png";
import sender from "../src/assets/sender.png";
import John from "../src/assets/hrOne.png";
import Sarah from "../src/assets/chat.png";
import Lisa from "../src/assets/hr4.png";
import mike from "../src/assets/James.png";
import DB from "../src/assets/DB.png";
import DB2 from "../src/assets/DB2.png";

export const hrDashboardData = {
  title: "cARD",
  birthdayCelebrants: [
    // {
    //   name: "Sarah Johnson",
    //   initials: "SJ",
    //   image: { Img },
    // },
    {
      name: "Mike Chen",
      initials: "MC",
      image:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Emma Davis",
      initials: "ED",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "John Smith",
      initials: "JS",
      image:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Lisa Wang",
      initials: "LW",
      image:
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face",
    },
  ],
  workAnniversaries: [
    {
      name: "John Smith",
      initials: "JS",
      years: 5,
      image:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Lisa Wang",
      initials: "LW",
      years: 3,
      image:
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "David Brown",
      initials: "DB",
      years: 7,
      image:
        "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Sarah Johnson",
      initials: "SJ",
      years: 2,
      image:
        "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Mike Chen",
      initials: "MC",
      years: 1,
      image:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Emma Davis",
      initials: "ED",
      years: 4,
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Alex Johnson",
      initials: "AJ",
      years: 6,
      image:
        "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Maria Garcia",
      initials: "MG",
      years: 8,
      image:
        "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "James Wilson",
      initials: "JW",
      years: 3,
      image:
        "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Sophie Chen",
      initials: "SC",
      years: 2,
      image:
        "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop&crop=face",
    },
  ],
  holidays: [
    {
      date: "1st October",
      name: "Independence Day",
      country: "Nigeria",
      flag: "🇳🇬",
    },
    {
      date: "1st October",
      name: "Independence Day",
      country: "Cyprus",
      flag: "🇨🇾",
    },
    { date: "4th July", name: "Independence Day", country: "USA", flag: "🇺🇸" },
  ],
  notifications: [
    {
      id: 1,
      initials: "AD",
      image: require("../src/assets/notificationBody.png"),
      message: "Your payment invoice request has been approved by Admin",
      time: "5min ago",
      status: "approved",
    },
    {
      id: 2,
      initials: "HR",
      image: require("../src/assets/notificationBody.png"),
      message: "Your leave request has been approved by Manager",
      time: "1 hour ago",
      status: "approved",
    },
    {
      id: 3,
      initials: "AD",
      image:
        "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=150&h=150&fit=crop&crop=face",
      message: "New policy update requires your attention",
      time: "2 hours ago",
      status: "pending",
    },
  ],
  activities: [
    {
      id: 1,
      initials: "JD",
      image:
        "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=150&h=150&fit=crop&crop=face",
      message: "Completed onboarding process.",
      time: "Just now",
    },
    {
      id: 2,
      initials: "SM",
      image:
        "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=face",
      message: "Updated profile information.",
      time: "50 minutes ago",
    },
    {
      id: 3,
      initials: "LW",
      image:
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face",
      message: "Submitted timesheet for approval.",
      time: "3 hours ago",
    },
    {
      id: 4,
      initials: "DB",
      image:
        "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face",
      message: "Enrolled in health insurance plan.",
      time: "2 days ago",
    },
  ],
};

// Sales Dashboard Data
export const salesDashboardData = {
  title: "Sales Dashboard",
  birthdayCelebrants: [
    {
      name: "Alex Rodriguez",
      initials: "AR",
      image:
        "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Maria Garcia",
      initials: "MG",
      image:
        "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "James Wilson",
      initials: "JW",
      image:
        "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Sophie Chen",
      initials: "SC",
      image:
        "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop&crop=face",
    },
  ],
  workAnniversaries: [
    {
      name: "Alex Rodriguez",
      initials: "AR",
      years: 4,
      image:
        "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Maria Garcia",
      initials: "MG",
      years: 6,
      image:
        "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "James Wilson",
      initials: "JW",
      years: 2,
      image:
        "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Sophie Chen",
      initials: "SC",
      years: 1,
      image:
        "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Robert Kim",
      initials: "RK",
      years: 3,
      image:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Jennifer Lee",
      initials: "JL",
      years: 5,
      image:
        "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Michael Brown",
      initials: "MB",
      years: 7,
      image:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
    },
  ],
  holidays: [
    {
      date: "15th March",
      name: "Sales Conference",
      country: "Company Event",
      flag: "🏢",
    },
    { date: "1st April", name: "Q1 Review", country: "Internal", flag: "📊" },
  ],
  notifications: [
    {
      id: 1,
      initials: "MG",
      image:
        "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=150&h=150&fit=crop&crop=face",
      message: "New lead assigned from marketing campaign",
      time: "10min ago",
      status: "pending",
    },
    {
      id: 2,
      initials: "AR",
      image:
        "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?w=150&h=150&fit=crop&crop=face",
      message: "Deal worth $50K has been closed successfully",
      time: "1 hour ago",
      status: "approved",
    },
    {
      id: 3,
      initials: "SM",
      image:
        "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=face",
      message: "Monthly sales target achieved",
      time: "3 hours ago",
      status: "approved",
    },
  ],
  activities: [
    {
      id: 1,
      initials: "AR",
      image:
        "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?w=150&h=150&fit=crop&crop=face",
      message: "Closed deal with TechCorp Inc.",
      time: "Just now",
    },
    {
      id: 2,
      initials: "MG",
      image:
        "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=150&h=150&fit=crop&crop=face",
      message: "Scheduled demo with potential client.",
      time: "30 minutes ago",
    },
    {
      id: 3,
      initials: "JW",
      image:
        "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&h=150&fit=crop&crop=face",
      message: "Updated CRM with new prospects.",
      time: "2 hours ago",
    },
    {
      id: 4,
      initials: "SC",
      image:
        "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop&crop=face",
      message: "Completed sales training module.",
      time: "1 day ago",
    },
  ],
};

// Marketing Dashboard Data
export const marketingDashboardData = {
  title: "Marketing Dashboard",
  birthdayCelebrants: [
    {
      name: "Emily Johnson",
      initials: "EJ",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "David Kim",
      initials: "DK",
      image:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Rachel Green",
      initials: "RG",
      image:
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face",
    },
  ],
  workAnniversaries: [
    {
      name: "Emily Johnson",
      initials: "EJ",
      years: 3,
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "David Kim",
      initials: "DK",
      years: 2,
      image:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Rachel Green",
      initials: "RG",
      years: 4,
      image:
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Tom Wilson",
      initials: "TW",
      years: 1,
      image:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Anna Lee",
      initials: "AL",
      years: 5,
      image:
        "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face",
    },
  ],
  holidays: [
    {
      date: "20th March",
      name: "Marketing Summit",
      country: "Industry Event",
      flag: "📈",
    },
    {
      date: "5th April",
      name: "Campaign Launch",
      country: "Internal",
      flag: "🚀",
    },
  ],
  notifications: [
    {
      id: 1,
      initials: "EJ",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
      message: "Campaign performance report is ready for review",
      time: "15min ago",
      status: "pending",
    },
    {
      id: 2,
      initials: "DK",
      image:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
      message: "Social media engagement increased by 25%",
      time: "2 hours ago",
      status: "approved",
    },
    {
      id: 3,
      initials: "RG",
      image:
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face",
      message: "New brand guidelines have been approved",
      time: "4 hours ago",
      status: "approved",
    },
  ],
  activities: [
    {
      id: 1,
      initials: "EJ",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
      message: "Launched new email campaign.",
      time: "Just now",
    },
    {
      id: 2,
      initials: "DK",
      image:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
      message: "Updated website analytics dashboard.",
      time: "1 hour ago",
    },
    {
      id: 3,
      initials: "RG",
      image:
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face",
      message: "Created new brand assets.",
      time: "3 hours ago",
    },
    {
      id: 4,
      initials: "TW",
      image:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
      message: "Scheduled social media posts.",
      time: "5 hours ago",
    },
  ],
};

// Default/General Dashboard Data
export const defaultDashboardData = {
  title: "Company Dashboard",
  birthdayCelebrants: [
    {
      name: "Sarah Johnson",
      initials: "SJ",
      image:
        "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Mike Chen",
      initials: "MC",
      image:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Emma Davis",
      initials: "ED",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "John Smith",
      initials: "JS",
      image:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Lisa Wang",
      initials: "LW",
      image:
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face",
    },
  ],
  workAnniversaries: [
    {
      name: "John Smith",
      initials: "JS",
      years: 5,
      image:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Lisa Wang",
      initials: "LW",
      years: 3,
      image:
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "David Brown",
      initials: "DB",
      years: 7,
      image:
        "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Sarah Johnson",
      initials: "SJ",
      years: 2,
      image:
        "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Mike Chen",
      initials: "MC",
      years: 1,
      image:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Emma Davis",
      initials: "ED",
      years: 4,
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Alex Johnson",
      initials: "AJ",
      years: 6,
      image:
        "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Maria Garcia",
      initials: "MG",
      years: 8,
      image:
        "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "James Wilson",
      initials: "JW",
      years: 3,
      image:
        "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&h=150&fit=crop&crop=face",
    },
    {
      name: "Sophie Chen",
      initials: "SC",
      years: 2,
      image:
        "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop&crop=face",
    },
  ],
  holidays: [
    {
      date: "1st October",
      name: "Independence Day",
      country: "Nigeria",
      flag: "🇳🇬",
    },
    {
      date: "1st October",
      name: "Independence Day",
      country: "Cyprus",
      flag: "🇨🇾",
    },
  ],
  notifications: [
    {
      id: 1,
      initials: "AD",
      image: require("../src/assets/notificationBody.png"),
      message: "Your payment invoice request has been approved by Admin",
      time: "5min ago",
      status: "approved",
    },
    {
      id: 2,
      initials: "AD",
      image: require("../src/assets/notificationBody.png"),
      message: "Your payment invoice request has been approved by Admin",
      time: "5min ago",
      status: "approved",
    },
    {
      id: 3,
      initials: "AD",
      image: require("../src/assets/notificationBody.png"),
      message: "Your payment invoice request has been approved by Admin",
      time: "5min ago",
      status: "approved",
    },
  ],
  activities: [
    {
      id: 1,
      initials: "JD",
      image:
        "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=150&h=150&fit=crop&crop=face",
      message: "Upgraded to stand-alone.",
      time: "Just now",
    },
    {
      id: 2,
      initials: "SM",
      image:
        "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=face",
      message: "Upgraded to stand-alone.",
      time: "50 minutes ago",
    },
    {
      id: 3,
      initials: "LW",
      image:
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face",
      message: "Upgraded to stand-alone.",
      time: "3 hours ago",
    },
    {
      id: 4,
      initials: "DB",
      image:
        "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face",
      message: "Upgraded to stand-alone.",
      time: "2 days ago",
    },
  ],
};

// Engagement Data
export const engagement = [
  {
    id: 1,
    title: "Title Of Post",
    content:
      "Porro fugit consequatur ipsa voluptas neque omnis. Modi ex inventore corrupti. Placeat dolorem enim impedit non ut totam. Perspiciatis fugit ratione ut. Omnis voluptatem repellat porro modi. Saepe id sunt maiores odio quam quaerat illum sunt aut.",
    image: require("../src/assets/engagement.png"), // Replace with your image URL
    author: "Admin",
    date: "2/7/2023",
    likes: 60,
    loves: 24,
    comments: 2000,
    icon: EngagementImg,
    smallImage: smallImage,
    isPublic: true,
  },

  {
    id: 2,
    title: "Another Title",
    content:
      "Porro fugit consequatur ipsa voluptas neque omnis. Modi ex inventore corrupti. Placeat dolorem enim impedit non ut totam. Perspiciatis fugit ratione ut. Omnis voluptatem repellat porro modi. Saepe id sunt maiores odio quam quaerat illum sunt aut.",
    image: require("../src/assets/engagement.png"), // Replace with your image URL
    author: "Admin",
    date: "2/7/2023",
    likes: 80,
    loves: 24,
    comments: 3000,
    icon: EngagementImg,
    smallImage: smallImage,
    isPublic: false,
  },

  {
    id: 3,
    title: "Another Title",
    content:
      "Porro fugit consequatur ipsa voluptas neque omnis. Modi ex inventore corrupti. Placeat dolorem enim impedit non ut totam. Perspiciatis fugit ratione ut. Omnis voluptatem repellat porro modi. Saepe id sunt maiores odio quam quaerat illum sunt aut.",
    image: require("../src/assets/engagement.png"), // Replace with your image URL
    author: "Admin",
    date: "2/7/2023",
    likes: 80,
    loves: 24,
    comments: 3000,
    icon: EngagementImg,
    smallImage: smallImage,
    isPublic: false,
  },

  {
    id: 4,
    title: "Another Title",
    content:
      "Porro fugit consequatur ipsa voluptas neque omnis. Modi ex inventore corrupti. Placeat dolorem enim impedit non ut totam. Perspiciatis fugit ratione ut. Omnis voluptatem repellat porro modi. Saepe id sunt maiores odio quam quaerat illum sunt aut.",
    image: require("../src/assets/engagement.png"), // Replace with your image URL
    author: "Admin",
    date: "2/7/2023",
    likes: 80,
    loves: 24,
    comments: 3000,
    icon: EngagementImg,
    smallImage: smallImage,
    isPublic: false,
  },
  // Add more as needed...
];

export const mockGroups = [
  // GROUPS CATEGORY - Multiple items
  {
    id: "1",
    name: "Debbie Zoe - HR Lead",
    category: "Groups",
    isPinned: true,
    lastMessage: "Hey Jane, I sent you a document on discord...",
    time: "12:30",
    avatar: Debbie,
    pinnedMessages: [
      { id: "p1", text: "First pinned message" },
      { id: "p2", text: "Second pinned message" },
    ],
    messages: [
      {
        id: "m1",
        text: "Lorem ipsum dolor sit amet consectetur. Quam pulvinar tristique in lobortis aliquet justo duis cursus. Aenean ultrices sed purus duis massa enim. Tortor rhoncus.",
        senderImg: Debbie,
        sender: "James Smith",
        role: "UI/UX Designer",
        time: "11:00",
        isYou: false,
        date: "Today",
      },
      {
        id: "m2",
        text: "Lorem ipsum dolor sit amet consectetur. Quam pulvinar tristique in lobortis aliquet justo duis cursus. Aenean ultrices sed purus duis massa enim. Tortor rhoncus. Aenean ultrices sed purus duis massa enim. Tortor rhoncus.",
        senderImg: Debbie,
        sender: "James Smith",
        role: "UI/UX Designer",
        time: "11:00",
        isYou: false,
        date: "Today",
      },
      {
        id: "m3",
        text: "Lorem ipsum dolor sit amet consectetur. Quam pulvinar tristique in lobortis aliquet justo duis cursus. Aenean ultrices sed purus duis massa enim. Tortor rhoncus.",
        senderImg: Debbie,
        sender: "James Smith",
        role: "UI/UX Designer",
        time: "11:00",
        isYou: false,
        date: "Today",
      },
      {
        id: "m4",
        text: "Lorem ipsum dolor sit amet consectetur. Quam pulvinar tristique in lobortis aliquet justo duis cursus. Aenean ultrices sed purus duis massa enim. Tortor rhoncus.",
        sender: "You",
        role: "UI/UX Designer",
        time: "11:00",
        isYou: true,
        date: "Yesterday",
      },
    ],
    typing: "",
    membersOnline: 12,
    totalMembers: 50,
    memberAvatars: [
      require("../src/assets/chat.png"),
      require("../src/assets/chat.png"),
      require("../src/assets/chat.png"),
      require("../src/assets/chat.png"),
      require("../src/assets/chat.png"),
    ],
  },

  {
    id: "2",
    name: "Human Resource Dept.",
    category: "Groups",
    isPinned: true,
    lastMessage: "Hey Jane, I sent you a document on discord...",
    time: "12:30",
    avatar: HR,
    pinnedMessages: [],
    messages: [
      {
        id: "m5",
        text: "Lorem ipsum dolor sit amet consectetur. Quam pulvinar tristique in lobortis aliquet justo duis cursus. Aenean ultrices sed purus duis massa enim. Tortor rhoncus.",
        senderImg: James,
        sender: "James Smith",
        role: "UI/UX Designer",
        time: "11:00",
        isYou: false,
        date: "Today",
      },
      {
        id: "m6",
        text: "Lorem ipsum dolor sit amet consectetur. Quam pulvinar tristique in lobortis aliquet justo duis cursus. Aenean ultrices sed purus duis massa enim. Tortor rhoncus. Tortor rhoncus.Tortor rhoncus.Tortor rhoncus.",
        senderImg: Gideon,
        sender: "Sarah Johnson",
        role: "Product Designer",
        time: "11:05",
        isYou: false,
        date: "Today",
      },
      {
        id: "m7",
        text: "Lorem ipsum dolor sit amet consectetur. Quam pulvinar tristique in lobortis aliquet justo duis cursus. Aenean ultrices sed purus duis massa enim. Tortor rhoncus.",
        senderImg: sender,
        sender: "You",
        role: "UI/UX Designer",
        time: "11:10",
        isYou: true,
        date: "Today",
      },
    ],
    typing: "Debbie is typing...",
    membersOnline: 12,
    totalMembers: 50,
    memberAvatars: [hrOne, hrTwo, hrThree, hrFour],
  },

  {
    id: "3",
    name: "Human Resource Dept.",
    category: "Groups",
    isPinned: true,
    lastMessage: "Hey Jane, I sent you a document on discord...",
    time: "12:30",
    avatar: HR,
    pinnedMessages: [],
    messages: [
      {
        id: "m5",
        text: "Lorem ipsum dolor sit amet consectetur. Quam pulvinar tristique in lobortis aliquet justo duis cursus. Aenean ultrices sed purus duis massa enim. Tortor rhoncus.",
        senderImg: James,
        sender: "James Smith",
        role: "UI/UX Designer",
        time: "11:00",
        isYou: false,
        date: "Today",
      },
      {
        id: "m6",
        text: "Lorem ipsum dolor sit amet consectetur. Quam pulvinar tristique in lobortis aliquet justo duis cursus. Aenean ultrices sed purus duis massa enim. Tortor rhoncus. Tortor rhoncus.Tortor rhoncus.Tortor rhoncus.",
        senderImg: Gideon,
        sender: "Sarah Johnson",
        role: "Product Designer",
        time: "11:05",
        isYou: false,
        date: "Today",
      },
      {
        id: "m7",
        text: "Lorem ipsum dolor sit amet consectetur. Quam pulvinar tristique in lobortis aliquet justo duis cursus. Aenean ultrices sed purus duis massa enim. Tortor rhoncus.",
        senderImg: sender,
        sender: "You",
        role: "UI/UX Designer",
        time: "11:10",
        isYou: true,
        date: "Today",
      },
    ],
    typing: "Debbie is typing...",
    membersOnline: 12,
    totalMembers: 50,
    memberAvatars: [hrOne, hrTwo, hrThree, hrFour],
  },

  {
    id: "3",
    name: "Creative Team",
    category: "Groups",
    isPinned: false,
    lastMessage: "New project brief is ready for review",
    time: "11:45",
    avatar: HR,
    pinnedMessages: [],
    messages: [
      {
        id: "m8",
        text: "New project brief is ready for review. Please check your emails.",
        sender: "Mike Wilson",
        role: "Creative Director",
        time: "11:45",
        isYou: false,
        date: "Today",
      },
    ],
    typing: "",
    membersOnline: 15,
    totalMembers: 30,
    memberAvatars: [
      require("../src/assets/chat.png"),
      require("../src/assets/chat.png"),
    ],
  },

  {
    id: "4",
    name: "Creative Team",
    category: "Groups",
    isPinned: false,
    lastMessage: "New project brief is ready for review",
    time: "11:45",
    avatar: HR,
    pinnedMessages: [],
    messages: [
      {
        id: "m8",
        text: "New project brief is ready for review. Please check your emails.",
        senderImg: hrThree,
        sender: "Mike Wilson",
        role: "Creative Director",
        time: "11:45",
        isYou: false,
        date: "Today",
      },
    ],
    typing: "",
    membersOnline: 15,
    totalMembers: 30,
    memberAvatars: [
      require("../src/assets/chat.png"),
      require("../src/assets/chat.png"),
    ],
  },

  {
    id: "5",
    name: "Project Alpha",
    category: "Groups",
    isPinned: false,
    lastMessage: "Meeting scheduled for tomorrow",
    time: "10:30",
    avatar: HR,
    pinnedMessages: [],
    messages: [
      {
        id: "m9",
        text: "Meeting scheduled for tomorrow at 2 PM. Don't forget to prepare your updates.",
        senderImg: hrThree,
        sender: "Alex Chen",
        role: "Project Manager",
        time: "10:30",
        isYou: false,
        date: "Today",
      },
    ],
    typing: "",
    membersOnline: 7,
    totalMembers: 20,
    memberAvatars: [require("../src/assets/chat.png")],
  },

  {
    id: "6",
    name: "Project Alpha",
    category: "Groups",
    isPinned: false,
    lastMessage: "Meeting scheduled for tomorrow",
    time: "10:30",
    avatar: HR,
    pinnedMessages: [],
    messages: [
      {
        id: "m9",
        text: "Meeting scheduled for tomorrow at 2 PM. Don't forget to prepare your updates.",
        senderImg: hrTwo,
        sender: "Alex Chen",
        role: "Project Manager",
        time: "10:30",
        isYou: false,
        date: "Today",
      },
    ],
    typing: "",
    membersOnline: 7,
    totalMembers: 20,
    memberAvatars: [require("../src/assets/chat.png")],
  },

  // DEPARTMENT CATEGORY - Multiple items
  {
    id: "5",
    name: "UI/UX Dept.",
    category: "Department",
    isPinned: true,
    lastMessage: "Code review completed successfully",
    time: "09:15",
    avatar: require("../src/assets/chat.png"),
    pinnedMessages: [],
    messages: [
      {
        id: "m10",
        text: "Code review completed successfully. Great work everyone!",
        sender: "David Kim",
        senderImg: Debbie,
        role: "Senior Developer",
        time: "09:15",
        isYou: false,
        date: "Today",
      },
      {
        id: "m11",
        text: "Thanks for the feedback. I'll implement the suggested changes.",
        senderImg: Debbie,
        sender: "You",
        role: "UI/UX Designer",
        time: "09:20",
        isYou: true,
        date: "Today",
      },
    ],
    typing: "",
    membersOnline: 18,
    totalMembers: 45,
    memberAvatars: [
      require("../src/assets/chat.png"),
      require("../src/assets/chat.png"),
      require("../src/assets/chat.png"),
    ],
  },

  {
    id: "6",
    name: "Human Resource Dept",
    category: "Department",
    isPinned: true,
    lastMessage: "Campaign results are looking great!",
    time: "08:45",
    avatar: HR,
    pinnedMessages: [],
    messages: [
      {
        id: "m12",
        text: "Campaign results are looking great! We exceeded our target by 25%.",
        senderImg: Debbie,
        sender: "Emma Davis",
        role: "Marketing Manager",
        time: "08:45",
        isYou: false,
        date: "Today",
      },
      {
        id: "m13",
        text: "Fantastic news! What's our next step?",
        senderImg: Debbie,
        sender: "James Smith",
        role: "UI/UX Designer",
        time: "08:50",
        isYou: false,
        date: "Today",
      },
      {
        id: "m14",
        text: "Let's schedule a meeting to discuss the next phase.",
        sender: "You",
        role: "UI/UX Designer",
        time: "08:55",
        isYou: true,
        date: "Today",
      },
    ],
    typing: "",
    membersOnline: 12,
    totalMembers: 28,
    memberAvatars: [
      require("../src/assets/chat.png"),
      require("../src/assets/chat.png"),
    ],
  },

  {
    id: "7",
    name: "UI/UX Department",
    category: "Department",
    isPinned: true,
    lastMessage: "Campaign results are looking great!",
    time: "08:45",
    avatar: HR,
    pinnedMessages: [],
    messages: [
      {
        id: "m12",
        text: "Campaign results are looking great! We exceeded our target by 25%.",
        senderImg: Debbie,
        sender: "Emma Davis",
        role: "Marketing Manager",
        time: "08:45",
        isYou: false,
        date: "Today",
      },
      {
        id: "m13",
        text: "Fantastic news! What's our next step?",
        senderImg: Debbie,
        sender: "James Smith",
        role: "UI/UX Designer",
        time: "08:50",
        isYou: false,
        date: "Today",
      },
      {
        id: "m14",
        text: "Let's schedule a meeting to discuss the next phase.",
        sender: "You",
        role: "UI/UX Designer",
        time: "08:55",
        isYou: true,
        date: "Today",
      },
    ],
    typing: "",
    membersOnline: 12,
    totalMembers: 28,
    memberAvatars: [
      require("../src/assets/chat.png"),
      require("../src/assets/chat.png"),
    ],
  },

  {
    id: "8",
    name: "Software Development",
    category: "Department",
    isPinned: false,
    lastMessage: "Q4 targets achieved ahead of schedule",
    time: "14:20",
    avatar: HR,
    pinnedMessages: [],
    messages: [
      {
        id: "m15",
        text: "Q4 targets achieved ahead of schedule! Celebrating our success.",
        senderImg: Debbie,
        sender: "Robert Taylor",
        role: "Sales Director",
        time: "14:20",
        isYou: false,
        date: "Yesterday",
      },
    ],
    typing: "",
    membersOnline: 9,
    totalMembers: 22,
    memberAvatars: [require("../src/assets/chat.png")],
  },

  {
    id: "9",
    name: "Software Development",
    category: "Department",
    isPinned: false,
    lastMessage: "Q4 targets achieved ahead of schedule",
    time: "14:20",
    avatar: HR,
    pinnedMessages: [],
    messages: [
      {
        id: "m15",
        text: "Q4 targets achieved ahead of schedule! Celebrating our success.",
        senderImg: Debbie,
        sender: "Robert Taylor",
        role: "Sales Director",
        time: "14:20",
        isYou: false,
        date: "Yesterday",
      },
    ],
    typing: "",
    membersOnline: 9,
    totalMembers: 22,
    memberAvatars: [require("../src/assets/chat.png")],
  },

  {
    id: "10",
    name: "Software Development",
    category: "Department",
    isPinned: false,
    lastMessage: "Q4 targets achieved ahead of schedule",
    time: "14:20",
    avatar: HR,
    pinnedMessages: [],
    messages: [
      {
        id: "m15",
        text: "Q4 targets achieved ahead of schedule! Celebrating our success.",
        senderImg: Debbie,
        sender: "Robert Taylor",
        role: "Sales Director",
        time: "14:20",
        isYou: false,
        date: "Yesterday",
      },
    ],
    typing: "",
    membersOnline: 9,
    totalMembers: 22,
    memberAvatars: [require("../src/assets/chat.png")],
  },

  {
    id: "11",
    name: "Software Development",
    category: "Department",
    isPinned: false,
    lastMessage: "Q4 targets achieved ahead of schedule",
    time: "14:20",
    avatar: HR,
    pinnedMessages: [],
    messages: [
      {
        id: "m15",
        text: "Q4 targets achieved ahead of schedule! Celebrating our success.",
        senderImg: Debbie,
        sender: "Robert Taylor",
        role: "Sales Director",
        time: "14:20",
        isYou: false,
        date: "Yesterday",
      },
    ],
    typing: "",
    membersOnline: 9,
    totalMembers: 22,
    memberAvatars: [require("../src/assets/chat.png")],
  },

  {
    id: "12",
    name: "Software Development",
    category: "Department",
    isPinned: false,
    lastMessage: "Q4 targets achieved ahead of schedule",
    time: "14:20",
    avatar: HR,
    pinnedMessages: [],
    messages: [
      {
        id: "m15",
        text: "Q4 targets achieved ahead of schedule! Celebrating our success.",
        senderImg: Debbie,
        sender: "Robert Taylor",
        role: "Sales Director",
        time: "14:20",
        isYou: false,
        date: "Yesterday",
      },
    ],
    typing: "",
    membersOnline: 9,
    totalMembers: 22,
    memberAvatars: [require("../src/assets/chat.png")],
  },
  {
    id: "13",
    name: "Software Development",
    category: "Department",
    isPinned: false,
    lastMessage: "Q4 targets achieved ahead of schedule",
    time: "14:20",
    avatar: HR,
    pinnedMessages: [],
    messages: [
      {
        id: "m15",
        text: "Q4 targets achieved ahead of schedule! Celebrating our success.",
        senderImg: Debbie,
        sender: "Robert Taylor",
        role: "Sales Director",
        time: "14:20",
        isYou: false,
        date: "Yesterday",
      },
    ],
    typing: "",
    membersOnline: 9,
    totalMembers: 22,
    memberAvatars: [require("../src/assets/chat.png")],
  },

  {
    id: "14",
    name: "Software Development",
    category: "Department",
    isPinned: false,
    lastMessage: "Q4 targets achieved ahead of schedule",
    time: "14:20",
    avatar: HR,
    pinnedMessages: [],
    messages: [
      {
        id: "m15",
        text: "Q4 targets achieved ahead of schedule! Celebrating our success.",
        senderImg: Debbie,
        sender: "Robert Taylor",
        role: "Sales Director",
        time: "14:20",
        isYou: false,
        date: "Yesterday",
      },
    ],
    typing: "",
    membersOnline: 9,
    totalMembers: 22,
    memberAvatars: [require("../src/assets/chat.png")],
  },

  {
    id: "15",
    name: "Software Development",
    category: "Department",
    isPinned: false,
    lastMessage: "Q4 targets achieved ahead of schedule",
    time: "14:20",
    avatar: HR,
    pinnedMessages: [],
    messages: [
      {
        id: "m15",
        text: "Q4 targets achieved ahead of schedule! Celebrating our success.",
        senderImg: Debbie,
        sender: "Robert Taylor",
        role: "Sales Director",
        time: "14:20",
        isYou: false,
        date: "Yesterday",
      },
    ],
    typing: "",
    membersOnline: 9,
    totalMembers: 22,
    memberAvatars: [require("../src/assets/chat.png")],
  },

  // PERSONAL CATEGORY - Multiple items
  {
    id: "8",
    name: "Feranmi",
    category: "Personal",
    isPinned: true,
    lastMessage: "Thanks for the design feedback",
    time: "16:30",
    avatar: require("../src/assets/chat.png"),
    pinnedMessages: [],
    messages: [
      {
        id: "m16",
        text: "Thanks for the design feedback. I've made the requested changes.",
        sender: "Feranmi",
        role: "Product Designer",
        time: "16:30",
        isYou: false,
        date: "Today",
      },
      {
        id: "m17",
        text: "Looks much better now! Great work.",
        sender: "You",
        role: "UI/UX Designer",
        time: "16:35",
        isYou: true,
        date: "Today",
      },
    ],
    typing: "",
    membersOnline: 1,
    totalMembers: 2,
    memberAvatars: [require("../src/assets/chat.png")],
  },

  {
    id: "9",
    name: "Sarah Johnson",
    category: "Personal",
    isPinned: true,
    lastMessage: "Can we discuss the wireframes?",
    time: "15:45",
    avatar: require("../src/assets/chat.png"),
    pinnedMessages: [],
    messages: [
      {
        id: "m18",
        text: "Can we discuss the wireframes? I have some suggestions for improvement.",
        sender: "Sarah Johnson",
        role: "Product Designer",
        time: "15:45",
        isYou: false,
        date: "Today",
      },
      {
        id: "m19",
        text: "Sure! Let's schedule a quick call this afternoon.",
        sender: "You",
        role: "UI/UX Designer",
        time: "15:50",
        isYou: true,
        date: "Today",
      },
      {
        id: "m20",
        text: "Perfect! I'll send you a calendar invite.",
        sender: "Sarah Johnson",
        role: "Product Designer",
        time: "15:52",
        isYou: false,
        date: "Today",
      },
    ],
    typing: "",
    membersOnline: 1,
    totalMembers: 2,
    memberAvatars: [require("../src/assets/chat.png")],
  },
  {
    id: "10",
    name: "Mike Wilson",
    category: "Personal",
    isPinned: false,
    lastMessage: "Project deadline moved to next week",
    time: "13:10",
    avatar: require("../src/assets/chat.png"),
    pinnedMessages: [],
    messages: [
      {
        id: "m21",
        text: "Project deadline moved to next week. This gives us more time to polish the design.",
        sender: "Mike Wilson",
        role: "Creative Director",
        time: "13:10",
        isYou: false,
        date: "Today",
      },
    ],
    typing: "",
    membersOnline: 1,
    totalMembers: 2,
    memberAvatars: [require("../src/assets/chat.png")],
  },
];

export const taskData = {
  "To-do": {
    count: 5,
    color: "",
    headerColor: "text-black",
    tasks: [
      {
        id: 1,
        title: "Create a Wireframe for SMS",
        tags: [
          { name: "CeHR01", color: "border border-[#EBEEF2] text-[#606C80]" },
          { name: "Mobile", color: "border border-[#EBEEF2]  text-[#1D926F]" },
          { name: "Design", color: "bg-[#3B82F61A] text-[#2563EB]" },
          { name: "To-Do", color: "bg-[#EAB3081A] text-[#CA8A04]" },
        ],
        // assignees: [1, 2],
        assignees: [
          {
            id: 1,
            name: "John Doe",
            avatar: John,
          },
          {
            id: 2,
            name: "Sarah Kay",
            avatar: Sarah,
          },
        ],
        // assignees: [
        //   {
        //     id: 1,
        //     name: "John Doe",
        //     avatar: John,
        //   },
        //   {
        //     id: 2,
        //     name: "Sarah Kay",
        //     avatar: Sarah,
        //   },
        // ],
        moreCount: 5,
        comments: 2,
        attachments: 3,
        taskNumber: 4,
      },
      {
        id: 2,
        title: "Lorem ipsum dolor sit amet consectetur. Eget.",
        tags: [
          { name: "CeHR01", color: "bg-gray-100 text-gray-700" },
          { name: "Live", color: "bg-green-100 text-green-700" },
          { name: "Development", color: "bg-pink-100 text-pink-700" },
          { name: "To-Do", color: "bg-orange-100 text-orange-700" },
        ],
        // assignees: [1, 2],
        assignees: [
          {
            id: 1,
            name: "John Doe",
            avatar: John,
          },
          {
            id: 2,
            name: "Sarah Kay",
            avatar: Sarah,
          },
        ],

        moreCount: 5,
        comments: 2,
        attachments: 4,
        taskNumber: 1,
      },
      {
        id: 3,
        title: "Lorem ipsum dolor sit amet consectetur. Viverra eros.",
        tags: [
          { name: "CeHR01", color: "bg-gray-100 text-gray-700" },
          { name: "Project", color: "bg-blue-100 text-blue-700" },
          { name: "To-Do", color: "bg-orange-100 text-orange-700" },
        ],
        // assignees: [1],
        assignees: [
          {
            id: 1,
            name: "John Doe",
            avatar: Sarah,
          },
          {
            id: 2,
            name: "Sarah Kay",
            avatar: Lisa,
          },
        ],
        comments: 2,
        attachments: 4,
        taskNumber: 2,
      },
      {
        id: 4,
        title: "Create a Wireframe for SMS",
        tags: [
          { name: "CeHR01", color: "bg-gray-100 text-gray-700" },
          { name: "Web", color: "bg-red-100 text-red-700" },
          { name: "To-Do", color: "bg-orange-100 text-orange-700" },
        ],
        // assignees: [1, 2],
        // assignees: [
        //   {
        //     id: 1,
        //     name: "John Doe",
        //     avatar: John,
        //   },
        //   {
        //     id: 2,
        //     name: "Sarah Kay",
        //     avatar: Sarah,
        //   },
        // ],
        assignees: [
          {
            id: 1,
            name: "John Doe",
            avatar: Sarah,
          },
          {
            id: 2,
            name: "Sarah Kay",
            avatar: mike,
          },
        ],
        moreCount: 5,
        comments: 2,
        attachments: 4,
        taskNumber: 2,
      },
    ],
  },
  "Yet to start": {
    count: 3,
    color: "",
    headerColor: "text-red-600",
    tasks: [
      {
        id: 5,
        title: "Create a Wireframe for SMS",
        tags: [
          { name: "CeHR01", color: "bg-gray-100 text-gray-700" },
          { name: "Yet to start", color: "bg-red-100 text-red-700" },
        ],
        // assignees: [1, 3],
        assignees: [
          {
            id: 1,
            name: "John Doe",
            avatar: John,
          },
          {
            id: 2,
            name: "Sarah Kay",
            avatar: Sarah,
          },
        ],
        moreCount: 5,
        comments: 2,
        attachments: 4,
        taskNumber: 1,
      },
      {
        id: 6,
        title: "Lorem ipsum dolor sit",
        tags: [
          { name: "CeHR01", color: "bg-gray-100 text-gray-700" },
          { name: "Yet to start", color: "bg-red-100 text-red-700" },
        ],
        // assignees: [1, 3],
        assignees: [
          {
            id: 1,
            name: "John Doe",
            avatar: John,
          },
          {
            id: 2,
            name: "Sarah Kay",
            avatar: Sarah,
          },
        ],
        moreCount: 5,
        comments: 2,
        attachments: 4,
        taskNumber: 1,
      },
      {
        id: 7,
        title: "Lorem ipsum dolor sit",
        tags: [
          { name: "CeHR01", color: "bg-gray-100 text-gray-700" },
          { name: "Yet to start", color: "bg-red-100 text-red-700" },
        ],
        // assignees: [1],
        assignees: [
          {
            id: 1,
            name: "John Doe",
            avatar: John,
          },
          {
            id: 2,
            name: "Sarah Kay",
            avatar: Sarah,
          },
        ],
        comments: 2,
        attachments: 4,
        taskNumber: 1,
      },
      {
        id: 8,
        title: "Lorem ipsum dolor sit amet consectetur. Eget.",
        tags: [
          { name: "CeHR01", color: "bg-gray-100 text-gray-700" },
          { name: "Development", color: "bg-pink-100 text-pink-700" },
          { name: "Yet to start", color: "bg-red-100 text-red-700" },
        ],
        // assignees: [1, 3],
        assignees: [
          {
            id: 1,
            name: "John Doe",
            avatar: John,
          },
          {
            id: 2,
            name: "Sarah Kay",
            avatar: Sarah,
          },
        ],
        moreCount: 5,
        comments: 2,
        attachments: 4,
        taskNumber: 1,
      },
    ],
  },
  "In Progress": {
    count: 2,
    color: "",
    headerColor: "text-blue-600",
    tasks: [
      {
        id: 9,
        title: "Create a Wireframe for SMS",
        tags: [
          { name: "CeHR01", color: "bg-gray-100 text-gray-700" },
          { name: "In Progress", color: "bg-blue-100 text-blue-700" },
        ],
        // assignees: [1, 2],
        assignees: [
          {
            id: 1,
            name: "John Doe",
            avatar: John,
          },
          {
            id: 2,
            name: "Sarah Kay",
            avatar: Sarah,
          },
        ],
        moreCount: 5,
        comments: 2,
        attachments: 4,
        taskNumber: 1,
      },
      {
        id: 10,
        title: "Lorem ipsum dolor sit",
        tags: [
          { name: "CeHR01", color: "bg-gray-100 text-gray-700" },
          { name: "In Progress", color: "bg-blue-100 text-blue-700" },
        ],
        // assignees: [1, 2],
        assignees: [
          {
            id: 1,
            name: "John Doe",
            avatar: John,
          },
          {
            id: 2,
            name: "Sarah Kay",
            avatar: Sarah,
          },
        ],
        moreCount: 5,
        comments: 2,
        attachments: 4,
        taskNumber: 1,
      },
    ],
  },
  Done: {
    count: 5,
    color: "",
    headerColor: "text-green-600",
    tasks: [
      {
        id: 11,
        title: "Create a Wireframe for SMS",
        tags: [
          { name: "CeHR01", color: "bg-gray-100 text-gray-700" },
          { name: "Done", color: "bg-green-100 text-green-700" },
        ],
        // assignees: [1, 3],
        assignees: [
          {
            id: 1,
            name: "John Doe",
            avatar: John,
          },
          {
            id: 2,
            name: "Sarah Kay",
            avatar: Sarah,
          },
        ],
        moreCount: 5,
        comments: 2,
        attachments: 4,
        taskNumber: 1,
      },
      {
        id: 12,
        title: "Lorem ipsum dolor sit amet consectetur. Eget.",
        tags: [
          { name: "CeHR01", color: "bg-gray-100 text-gray-700" },
          { name: "Done", color: "bg-green-100 text-green-700" },
        ],
        // assignees: [1, 3],
        assignees: [
          {
            id: 1,
            name: "John Doe",
            avatar: John,
          },
          {
            id: 2,
            name: "Sarah Kay",
            avatar: Sarah,
          },
        ],
        moreCount: 5,
        comments: 2,
        attachments: 4,
        taskNumber: 1,
      },
      {
        id: 13,
        title: "Lorem ipsum dolor sit amet consectetur. Viverra eros.",
        tags: [
          { name: "CeHR01", color: "bg-gray-100 text-gray-700" },
          { name: "Done", color: "bg-green-100 text-green-700" },
        ],
        // assignees: [1, 3],
        assignees: [
          {
            id: 1,
            name: "John Doe",
            avatar: John,
          },
          {
            id: 2,
            name: "Sarah Kay",
            avatar: Sarah,
          },
        ],
        comments: 2,
        attachments: 4,
        taskNumber: 1,
      },
      {
        id: 14,
        title: "Create a Wireframe for SMS",
        tags: [
          { name: "CeHR01", color: "bg-gray-100 text-gray-700" },
          { name: "Done", color: "bg-green-100 text-green-700" },
        ],
        // assignees: [1, 2],
        assignees: [
          {
            id: 1,
            name: "John Doe",
            avatar: John,
          },
          {
            id: 2,
            name: "Sarah Kay",
            avatar: Sarah,
          },
        ],
        comments: 2,
        attachments: 4,
        taskNumber: 1,
      },
      {
        id: 15,
        title: "Lorem ipsum dolor sit amet consectetur. Eget.",
        tags: [
          { name: "CeHR01", color: "bg-gray-100 text-gray-700" },
          { name: "Done", color: "bg-green-100 text-green-700" },
        ],
        assignees: [1],
        comments: 2,
        attachments: 4,
        taskNumber: 1,
      },
    ],
  },
};

export const teamMembers = [
  { id: 1, name: "John", avatar: John, color: "bg-orange-500" },
  { id: 2, name: "Sarah", avatar: Sarah, color: "bg-pink-500" },
  { id: 3, name: "Mike", avatar: mike, color: "bg-gray-700" },
  { id: 4, name: "Lisa", avatar: Lisa, color: "bg-blue-500" },
];

export const mockUsers = {
  1: {
    id: 1,
    avatar: sender,
    name: "John Doe",
  },
  2: {
    id: 2,
    avatar: "https://randomuser.me/api/portraits/women/1.jpg",
    name: "Jane Smith",
  },
  3: {
    id: 3,
    avatar: "https://randomuser.me/api/portraits/men/2.jpg",
    name: "Peter Jones",
  },
  4: {
    id: 4,
    avatar: "https://randomuser.me/api/portraits/women/2.jpg",
    name: "Alice Brown",
  },
};

export const tassksData = [
  {
    id: "section-1",
    title: "Task 1",
    totalTasks: 15,
    startDate: "Apr 20, 11am",
    endDate: "Apr 30, 11am",
    isCollapsed: false, // Control visibility of sub-tasks
    tasks: [
      {
        id: "task-1-1",
        description: "Design a Lo-Fi Wireframe for E-commerce App Project",
        isCompleted: true,
        hasComment: true,
        dueDate: "Apr 22, 11am",
        statusColor: "bg-blue-500", // Represents the small colored bar
        // assignees: [1, 2],
        assignees: [
          {
            id: 1,
            name: "John Doe",
            avatar: John,
          },
          {
            id: 2,
            name: "Sarah Kay",
            avatar: Sarah,
          },
        ],
        moreAssignees: 5,
      },
      {
        id: "task-1-2",
        description: "Design a Lo-Fi Wireframe for E-commerce App Project",
        isCompleted: true,
        hasComment: false,
        dueDate: "Apr 22, 11am",
        statusColor: "bg-red-500",
        // assignees: [1, 3],
        assignees: [
          {
            id: 1,
            name: "John Doe",
            avatar: John,
          },
          {
            id: 2,
            name: "Sarah Kay",
            avatar: Sarah,
          },
        ],
        moreAssignees: 5,
      },
      {
        id: "task-1-3",
        description: "Design a Lo-Fi Wireframe for E-commerce App Project",
        isCompleted: true,
        hasComment: true,
        dueDate: "Apr 22, 11am",
        statusColor: "bg-purple-500",
        assignees: [2, 4],
        moreAssignees: 5,
      },
      {
        id: "task-1-4",
        description: "Design a Lo-Fi Wireframe for E-commerce App Project",
        isCompleted: true,
        hasComment: false,
        dueDate: "Apr 22, 11am",
        statusColor: "bg-green-500",
        // assignees: [1, 2],
        assignees: [
          {
            id: 1,
            name: "John Doe",
            avatar: John,
          },
          {
            id: 2,
            name: "Sarah Kay",
            avatar: Sarah,
          },
        ],
        moreAssignees: 5,
      },
      {
        id: "task-1-5",
        description: "Design a Lo-Fi Wireframe for E-commerce App Project",
        isCompleted: true,
        hasComment: false,
        dueDate: "Apr 22, 11am",
        statusColor: "bg-orange-500",
        assignees: [3, 4],
        moreAssignees: 5,
      },
    ],
  },
  {
    id: "section-2",
    title: "Task 2",
    totalTasks: 15,
    startDate: "Apr 20, 11am",
    endDate: "Apr 30, 11am",
    isCollapsed: true, // This section will be collapsed initially
    tasks: [
      {
        id: "task-2-1",
        description: "Review UX research findings and compile report",
        isCompleted: false,
        hasComment: false,
        dueDate: "Apr 25, 3pm",
        statusColor: "bg-pink-500",
        assignees: [1],
        moreAssignees: 0,
      },
      {
        id: "task-2-2",
        description: "Prepare presentation for stakeholder meeting",
        isCompleted: false,
        hasComment: true,
        dueDate: "Apr 28, 10am",
        statusColor: "bg-green-500",
        assignees: [2],
        moreAssignees: 0,
      },
    ],
  },
  {
    id: "section-3",
    title: "Task 2", // Repeating title as in your prototype
    totalTasks: 15,
    startDate: "Apr 20, 11am",
    endDate: "Apr 30, 11am",
    isCollapsed: true,
    tasks: [
      {
        id: "task-3-1",
        description: "This is another task for section 3",
        isCompleted: false,
        hasComment: false,
        dueDate: "Apr 25, 3pm",
        statusColor: "bg-red-500",
        // assignees: [1, 2],
        assignees: [
          {
            id: 1,
            name: "John Doe",
            avatar: John,
          },
          {
            id: 2,
            name: "Sarah Kay",
            avatar: Sarah,
          },
        ],
        moreAssignees: 0,
      },
    ],
  },
  {
    id: "section-4",
    title: "Task 2",
    totalTasks: 15,
    startDate: "Apr 20, 11am",
    endDate: "Apr 30, 11am",
    isCollapsed: true,
    tasks: [
      {
        id: "task-4-1",
        description: "This is another task for section 4",
        isCompleted: false,
        hasComment: false,
        dueDate: "Apr 25, 3pm",
        statusColor: "bg-green-500",
        assignees: [3],
        moreAssignees: 0,
      },
    ],
  },
  {
    id: "section-5",
    title: "Task 2",
    totalTasks: 15,
    startDate: "Apr 20, 11am",
    endDate: "Apr 30, 11am",
    isCollapsed: true,
    tasks: [
      {
        id: "task-5-1",
        description: "This is another task for section 5",
        isCompleted: false,
        hasComment: true,
        dueDate: "Apr 25, 3pm",
        statusColor: "bg-pink-500",
        assignees: [4],
        moreAssignees: 0,
      },
    ],
  },
];

// src/data.js

const BASE_DAY_WIDTH = 300; // The width (in pixels) for one day on the chart
const MIN_DAY = 17; // The start day number in your image
const MAX_DAY = 20.5; // The last vertical grid line shown in your image

export const TimelineData = [
  // Task 1: Blue, Lane 1 (17.0 to 18.5)
  {
    id: 1,
    start: 17.0,
    end: 18.5,
    lane: 1,
    color: "bg-task-blue",
    icon: DB,
    iconBg: "bg-blue-300",
  },

  // Task 2: Purple, Lane 2 (17.5 to 19.5)
  {
    id: 2,
    start: 17.5,
    end: 19.5,
    lane: 2,
    color: "bg-task-purple",
    icon: DB2,
    iconBg: "bg-purple-300",
  },

  // Task 3: Green, Lane 3 (17.0 to 18.0)
  {
    id: 3,
    start: 17.0,
    end: 18.0,
    lane: 3,
    color: "bg-task-green",
    icon: DB,
    iconBg: "bg-green-300",
  },

  // Task 4: Yellow, Lane 4 (17.8 to 18.8)
  {
    id: 4,
    start: 17.8,
    end: 18.8,
    lane: 4,
    color: "bg-task-yellow",
    icon: DB2,
    iconBg: "bg-yellow-300",
  },

  // Task 5: Pink, Lane 5 (18.2 to 19.0)
  {
    id: 5,
    start: 18.2,
    end: 19.0,
    lane: 5,
    color: "bg-task-pink",
    icon: DB,
    iconBg: "bg-pink-300",
  },

  // Task 6: Dark Blue, Lane 6 (18.5 to 19.5)
  {
    id: 6,
    start: 18.5,
    end: 19.5,
    lane: 6,
    color: "bg-task-dark-blue",
    icon: DB2,
    iconBg: "bg-blue-300",
  },

  // Task 7: Pink, Lane 7 (17.0 to 18.2)
  {
    id: 7,
    start: 17.0,
    end: 18.2,
    lane: 7,
    color: "bg-task-pink",
    icon: DB2,
    iconBg: "bg-pink-300",
  },

  // Task 8: Blue, Lane 8 (18.2 to 19.5)
  {
    id: 8,
    start: 18.2,
    end: 19.5,
    lane: 8,
    color: "bg-task-blue",
    icon: DB,
    iconBg: "bg-blue-300",
  },

  // Task 9: Dark Blue, Lane 6 (19.8 to 20.2)
  {
    id: 9,
    start: 19.8,
    end: 20.2,
    lane: 4,
    color: "bg-task-yellow",
    icon: DB2,
    iconBg: "bg-yellow-300",
  }, // Matches Yellow task icon

  // Task 10: Purple, Lane 5 (20.5 to 21.5 - extending the chart past 20.5)
  {
    id: 10,
    start: 20.5,
    end: 21.5,
    lane: 5,
    color: "bg-task-purple",
    icon: DB,
    iconBg: "bg-purple-300",
  },

  // Task 11: Dark Blue, Lane 8 (20.0 to 20.5)
  {
    id: 11,
    start: 20.0,
    end: 20.5,
    lane: 9,
    color: DB2,
    iconBg: "bg-blue-300",
  },

  // Task 12: Dark Blue, Lane 10 (20.0 to 20.5)
  {
    id: 12,
    start: 20.0,
    end: 20.5,
    lane: 10,
    color: "bg-task-dark-blue",
    icon: DB2,
    iconBg: "bg-blue-300",
  },

  // Task 13: Green, Lane 11 (20.5 to 21.0)
  {
    id: 13,
    start: 20.5,
    end: 21.0,
    lane: 11,
    color: DB,
    iconBg: "bg-green-300",
  },

  // Task 14: Purple, Lane 12 (20.0 to 22.0)
  {
    id: 14,
    start: 20.0,
    end: 22.0,
    lane: 12,
    color: "bg-task-purple",
    icon: DB2,
    iconBg: "bg-purple-300",
  },
];

const totalDuration =
  TimelineData.reduce((max, task) => Math.max(max, task.end), MAX_DAY) -
  MIN_DAY;
const totalWidth = totalDuration * BASE_DAY_WIDTH;
const maxLane = TimelineData.reduce((max, task) => Math.max(max, task.lane), 1);

export { BASE_DAY_WIDTH, MIN_DAY, totalWidth, totalDuration, maxLane };

export const reports = [
  {
    id: 1,
    assessor: "Cheryl E. Temilola",
    duration: "09:00 - 15:00 (6hrs)",
    date: "08th April, 2024",
    task: "UI/UX Design",
    email: "chere@gmail.com",
    avatar: assetsImg,
  },
  {
    id: 2,
    assessor: "Cheryl E. Temilola",
    duration: "09:00 - 15:00 (6hrs)",
    date: "08th April, 2024",
    task: "UI/UX Design",
    email: "chere@gmail.com",
    avatar: assetsImg,
  },
  {
    id: 3,
    assessor: "Cheryl E. Temilola",
    duration: "09:00 - 15:00 (6hrs)",
    date: "08th April, 2024",
    task: "UI/UX Design",
    email: "chere@gmail.com",
    avatar: assetsImg,
  },
  {
    id: 4,
    assessor: "Cheryl E. Temilola",
    duration: "09:00 - 15:00 (6hrs)",
    date: "08th April, 2024",
    task: "UI/UX Design",
    email: "chere@gmail.com",
    avatar: assetsImg,
  },
  {
    id: 5,
    assessor: "Cheryl E. Temilola",
    duration: "09:00 - 15:00 (6hrs)",
    date: "08th April, 2024",
    task: "UI/UX Design",
    email: "chere@gmail.com",
    avatar: assetsImg,
  },
  {
    id: 6,
    assessor: "Cheryl E. Temilola",
    duration: "09:00 - 15:00 (6hrs)",
    date: "08th April, 2024",
    task: "UI/UX Design",
    email: "chere@gmail.com",
    avatar: assetsImg,
  },
  {
    id: 7,
    assessor: "Cheryl E. Temilola",
    duration: "09:00 - 15:00 (6hrs)",
    date: "08th April, 2024",
    task: "UI/UX Design",
    email: "chere@gmail.com",
    avatar: assetsImg,
  },
  {
    id: 8,
    assessor: "Cheryl E. Temilola",
    duration: "09:00 - 15:00 (6hrs)",
    date: "08th April, 2024",
    task: "UI/UX Design",
    email: "chere@gmail.com",
    avatar: assetsImg,
  },
  {
    id: 9,
    assessor: "Cheryl E. Temilola",
    duration: "09:00 - 15:00 (6hrs)",
    date: "08th April, 2024",
    task: "UI/UX Design",
    email: "chere@gmail.com",
    avatar: assetsImg,
  },
  {
    id: 10,
    assessor: "Cheryl E. Temilola",
    duration: "09:00 - 15:00 (6hrs)",
    date: "08th April, 2024",
    task: "UI/UX Design",
    email: "chere@gmail.com",
    avatar: assetsImg,
  },
];
